import { Body, ButtonV2, Icon, Title, useConfig } from '@travelwin/core';
import { Trans, useTranslation } from 'react-i18next';

import Modal from '@/components/Modal';
import { getDiscountCodeFromCookie, isValidDiscountCode } from '@/utils';

const DiscountPopup = ({
  discountCode,
  showModal,
  onClose,
}: {
  discountCode: string | null;
  showModal: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const discountCodeFromCookie = getDiscountCodeFromCookie();
  const { PROMO_VOUCHER_POPUP_ENABLED } = useConfig();
  const isValid = isValidDiscountCode(discountCodeFromCookie);

  if (!PROMO_VOUCHER_POPUP_ENABLED) return null;

  if (typeof window === 'undefined') return null;

  if (!isValid) return null;

  return (
    <Modal
      toggle={() => {
        onClose();
      }}
      on={showModal}
      closeOnBackgroundClick
      closeOnEscapeClick
    >
      <div className="flex flex-column text-center align-center gap-16">
        <Icon name="discountIcon" />

        <Title data-testid="title-welcome-discount" level={4}>
          <Trans
            i18nKey="discount-popup.title"
            defaults="You've just unlocked an exclusive deal with code {{discountCode}}."
            values={{ discountCode }}
          />
        </Title>
        <div>
          <Body>
            {t(
              'discount-popup.description1',
              'Your special discount is waiting, it will be automatically applied at checkout. Don’t miss out, continue shopping and save now!',
            )}
          </Body>
        </div>
        <div />
        <ButtonV2
          intent="brand-green"
          variant="primary"
          fluid
          onClick={() => onClose()}
        >
          {t('discount-popup.continue', 'CONTINUE')}
        </ButtonV2>
        <div />
      </div>
    </Modal>
  );
};

export default DiscountPopup;
